import type { RootState } from '@/redux/store';

export const selectActiveAgentId = (state: RootState) => state.command.activeAgentId;
export const selectActiveSessionId = (state: RootState) => state.command.activeSessionId;
export const selectActiveSessionAgentId = (state: RootState) => state.command.activeSessionAgentId;
export const selectSidebarOpen = (state: RootState) => state.command.sidebarOpen;
export const selectSelectedModel = (state: RootState) => state.command.selectedModel;
export const selectTypingTitle = (state: RootState) => state.command.typingTitle;
